// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__1BbAq","primary":"styles_primary__2iT7h","secondary":"styles_secondary__2dcEo","third":"styles_third__3wsv9"};